// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1EdJy","subheader":"ReorderModal_subheader__3yQXf","listWrap":"ReorderModal_listWrap__2GF88"};